function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresenceQueueAway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14,17.88A4.66,4.66,0,0,0,18.37,13a.24.24,0,0,1,0-.12A4.48,4.48,0,0,0,14,8.29h-.13A4.48,4.48,0,0,0,9.65,13,4.64,4.64,0,0,0,14,17.88Z",
    style: {
      fill: "#00a8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.22,22.33c0-.33,0-.66.08-1a3.71,3.71,0,0,1-.88.1H13.8a3.34,3.34,0,0,1-2.19-.72,6.36,6.36,0,0,0-1-.88,1.76,1.76,0,0,0-2.11.35,16.18,16.18,0,0,0-2.16,3.38L6,24.35c-.15.33-.3.88-.08,1.17A1.86,1.86,0,0,0,7.23,26h9A7.11,7.11,0,0,1,15.22,22.33Z",
    style: {
      fill: "#00a8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.77,11.06a.86.86,0,0,1,.83.88v1.92a.86.86,0,0,1-.83.88h-1a.82.82,0,0,1-.83-.81v-2a1.1,1.1,0,0,1,.57-.84.11.11,0,0,0,.1-.08h0a5.76,5.76,0,0,0-5.48-4.16A6,6,0,0,0,8.59,11c0,.19.1.09.29.19a.76.76,0,0,1,.45.77v1.87a.86.86,0,0,1-.64.87c-.1.1,0,.19,0,.29a5.72,5.72,0,0,0,3.8,3.76c.44.08.17-.49,1-.49H15a.65.65,0,0,1,.65.65h0v.77a.66.66,0,0,1-.63.67H13.48c-.37,0-.64-.1-.74-.47a.53.53,0,0,0-.45-.29,7,7,0,0,1-4.38-4.39c-.09-.19-.09-.36-.36-.36l-.09-.1a.88.88,0,0,1-.87-.83v-2a.93.93,0,0,1,.87-.84c.1,0,.28,0,.28-.18A6.75,6.75,0,0,1,14.09,6a6.56,6.56,0,0,1,6.37,4.92A.5.5,0,0,0,20.77,11.06Z",
    style: {
      fill: "#00a8e9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25,16a5,5,0,1,0,5,4.95,5,5,0,0,0-5-4.95Zm0,8.77A3.79,3.79,0,1,1,25,20.93h0a3.79,3.79,0,0,1-3.79,3.76Z",
    style: {
      fill: "#7c7c7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.57 20.61 21.57 18.27 20.4 18.27 20.4 21.77 21.57 21.77 23.91 21.77 23.91 20.61 21.57 20.61",
    style: {
      fill: "#7c7c7c"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresenceQueueAway);
export default __webpack_public_path__ + "static/media/presence-queue-away.c73cf377.svg";
export { ForwardRef as ReactComponent };